import axios from 'axios'
import { apiObject, moveableObject } from './apiobject'

const reports = {
  ...apiObject,
  url: '/reports/reports/',
  downloadReport (id) {
    return axios.get(`${this.url}${id}/download/`, {
      responseType: 'arraybuffer'
    })
  }
}

const forms = {
  ...reports,
  url: '/reports/forms/',
}

const contactFile = {
  ...reports,
  url: '/reports/contact-files/',
}

export default {
  reports,
  forms,
  contactFile
}
